import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.url,
    onClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" < ", -1)),
      _createVNode(_component_TranslatedText, { path: _ctx.textKey }, null, 8, ["path"])
    ]),
    _: 1
  }, 8, ["to", "onClick"]))
}